import * as React from 'react';
import { useSelectMenu } from './useSelectMenu';

export type SelectMenuContextValues = ReturnType<typeof useSelectMenu> | null;

export const SelectMenuContext = React.createContext<SelectMenuContextValues>(null);

export function useSelectMenuContext() {
    const context = React.useContext(SelectMenuContext);
    if (context == null) {
        throw new Error('SelectMenu child components must be wrapped in <SelectMenu />');
    }
    return context;
}
